export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14 bg-background-50 rounded-2xl p-8 md:p-12">
          <div className="flex-shrink-0 w-48 h-48 md:w-56 md:h-56 rounded-2xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20mockup%20displaying%20manga%20reader%20app%20interface%20with%20colorful%20comic%20pages%20on%20screen%2C%20clean%20minimal%20device%20frame%2C%20warm%20amber%20and%20cream%20app%20UI%20design%2C%20professional%20product%20photography%20style%2C%20soft%20natural%20lighting%20on%20white%20surface&width=560&height=560&seq=app-mockup&orientation=squarish"
              alt="51漫画APP客户端界面展示"
              className="w-full h-full object-cover object-top"
            />
          </div>

          <div className="flex-1 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1 bg-accent-100 rounded-full mb-4">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-smartphone-line text-accent-600 text-sm"></i>
              </div>
              <span className="text-xs font-medium text-accent-700 whitespace-nowrap">
                移动端专属体验
              </span>
            </div>

            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-4">
              51漫画APP · 随时随地离线畅读
            </h2>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-lg mx-auto lg:mx-0">
              下载51漫画客户端，享受更流畅的51漫画免费版下载体验。支持全集离线缓存、夜间阅读模式、智能书签同步，让您在任何场景下都能沉浸式阅读喜爱的漫画作品。
              51漫画下载资源与网页端实时同步，一键批量缓存，地铁通勤、长途旅行皆可畅享无网络阅读。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
              <div className="flex items-center gap-2 px-4 py-2 bg-background-100 rounded-lg">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-android-line text-foreground-600 text-base"></i>
                </div>
                <span className="text-xs font-medium text-foreground-700 whitespace-nowrap">Android版</span>
              </div>
              <div className="flex items-center gap-2 px-4 py-2 bg-background-100 rounded-lg">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-apple-line text-foreground-600 text-base"></i>
                </div>
                <span className="text-xs font-medium text-foreground-700 whitespace-nowrap">iOS版</span>
              </div>
              <div className="flex items-center gap-2 px-4 py-2 bg-background-100 rounded-lg">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-computer-line text-foreground-600 text-base"></i>
                </div>
                <span className="text-xs font-medium text-foreground-700 whitespace-nowrap">桌面版</span>
              </div>
            </div>

            <a
              href="#index"
              className="inline-flex items-center gap-2 mt-6 px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm rounded-full transition-all whitespace-nowrap cursor-pointer"
            >
              了解更多
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-xs"></i>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}